import { claimPayCseStat, prtClmPV, prtAckLtrs, phCltGrps, clmClsTypes, salutation } from '@/const/claims'
import { commonMixins } from '@/mixins/common/commonMixin'
import MessageMixin from '@/mixins/message'
import store from '@/store'
import { expandURI } from '@/utils/ajax'
import { formatDisplayNumber } from '@/utils/number'
import { CLAIMS_LIFECYCLE } from '@/store/types'
export const ClaimCommonMixin = {
  data() {
    return {
      paymentTypes: [],
      acctNoSuffixes: []
    }
  },
  computed: {
    cseStatList() {
      const list = Object.freeze(claimPayCseStat)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    prtClmPVList() {
      const list = Object.freeze(prtClmPV)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    clmClsTypeList() {
      const list = Object.freeze(clmClsTypes)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    prtAckLtrList() {
      const list = Object.freeze(prtAckLtrs)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    phCltGrpList() {
      const list = Object.freeze(phCltGrps)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    salutationList() {
      const list = Object.freeze(salutation)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    }
  },
  methods: {
    async fetchPaymentTypes() {
      const apiUrl = this.claimDetail.menu.paymentTypes
      if (apiUrl) {
        try {
          this.paymentTypes = []
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            data.map(element => {
              const obj = {
                label: element.label,
                value: element.value,
                gstInc: element.secondaryValue
              }
              this.paymentTypes.push(obj)
            })
          }
        } catch (err) {
          this.paymentTypes = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchAcctNoSuffixes() {
      const apiUrl = store.state.claims.claimDetail.menu.acctNoSuffixes
      if (apiUrl) {
        try {
          this.acctNoSuffixes = []
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            data.map(element => {
              const obj = {
                label: element.label,
                value: element.value
              }
              this.acctNoSuffixes.push(obj)
            })
          }
        } catch (err) {
          this.acctNoSuffixes = []
          const { data } = err.response
          if (data) {
            this.notify(data)
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async checkUsrClmLimRes() {
      try {
        const apiUrl = this.$store.state.commons.menu.checkUsrClmLimRes
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.data
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async checkUsrClmLimPayt() {
      try {
        const apiUrl = this.$store.state.commons.menu.checkUsrClmLimPayt
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.data
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async checkUsrClmLimStatus() {
      try {
        const apiUrl = this.$store.state.commons.menu.checkUsrClmLimStatus
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.data
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async doPromptAuth(data, form) {
      if (!data || data.result !== true || !data.pendList || data.pendList.length === 0) return
      let authContent = ''
      if (form === 'reserve') {
        authContent = 'There is a claim reserve pending authorisation:\n'
        for (const item of data.pendList) {
          authContent += `- (${item.clmtNo}, ${item.clmItem}, ${item.clmResCat}, SGD ${formatDisplayNumber(item.reserveLoc, 2)})\n`
        }
        this.exceedLimit = 'reserve'
        this.reserveOrPayment = true
        this.pendingReserve = true
      } else if (form === 'payment') {
        authContent = 'There is a claim payment pending authorisation:\n'
        for (const item of data.pendList) {
          authContent += `- (${item.branch}, ${item.tranType1}, ${item.docNo || 'N/A'}, ${item.fund}, SGD ${formatDisplayNumber(item.paytAmtLoc, 2)})\n`
        }
        this.exceedLimit = 'payment'
        this.reserveOrPayment = false
        this.pendingReserve = false
      } else {
        authContent = 'There is a claim status pending authorisation:\n'
        this.exceedLimit = 'status'
        this.reserveOrPayment = null
        this.pendingReserve = false
      }
      authContent += 'Proceed to authorise?'
      this.authTxt = authContent
      this.promptAuth = true
      this.firstEnterScreen = false
    },
    async doAuthPend() {
      try {
        let apiUrl
        if (this.exceedLimit === 'reserve') {
          apiUrl = this.$store.state.commons.menu.authPendClmRes
        } else if (this.exceedLimit === 'payment') {
          apiUrl = this.$store.state.commons.menu.authPendClmPayt
        } else {
          apiUrl = this.$store.state.commons.menu.authPendClmStatus
        }
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.data.result === true) {
            this.promptCaptureAuth = true
          } else {
            this.commonInfo.usrClmLim = false
            this.promptAuthApproveTxt = true
            this.getSideControlMenu('clmstatus').show = false
          }
          return result.data.data.result
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async doDelPend() {
      try {
        let apiUrl = await this.getDoDelPendAPIURL()
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (this.exceedLimit === 'reserve') {
            const clmResCat = result.data.data.clmResCat
            this.commonInfo.clmAccumRes = this.commonInfo.clmAccumRes.filter(item => {
              return !(item.clmResCat === clmResCat && item.status === 'P')
            })
            this.commonInfo.clmReses = this.commonInfo.clmReses.filter(item => {
              return !(item.clmResCat === clmResCat && item.status === 'P')
            })
            this.promptCaptureAuthDel = false
            if (this.$store.state.claims.claimDetail.claimLifeCycle === 5) {
              this.$store.commit(CLAIMS_LIFECYCLE, 5)
              this.doInit()
              this.activeHeaders = this.reserveHeaders[this.displayCurr]
            }
          } else if (this.exceedLimit === 'payment') {
            this.commonInfo.clmPayts = this.commonInfo.clmPayts.filter(
              item => item.status !== 'P'
            )
            this.promptCaptureAuthDel = false
          } else {
            this.commonInfo.claimStatuses = this.commonInfo.claimStatuses.filter(
              item => item.status !== 'P'
            )
            this.promptCaptureAuthDel = false
            if (this.$store.state.claims.claimDetail.claimLifeCycle === 5) {
              this.$store.commit(CLAIMS_LIFECYCLE, 5)
              this.doInit()
              this.activeHeaders = this.reserveHeaders[this.displayCurr]
            }
          }
          return result
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async getDoDelPendAPIURL () {
      let apiUrl
      if (this.exceedLimit === 'reserve') {
        apiUrl = this.$store.state.commons.menu.delPendClmRes
      } else if (this.exceedLimit === 'payment') {
        apiUrl = this.$store.state.commons.menu.delPendClmPayt
      } else {
        apiUrl = this.$store.state.commons.menu.delPendClmStatus
      }
      return apiUrl
    },
    async getPendClmAll() {
      let apiUrl = this.$store.state.commons.menu.getPendClmAll
      if (apiUrl) {
        this.loadingFlag = true
        this.mainForm.clmNo = this.commonInfo.clmNo
        this.$http.get(expandURI(apiUrl, this.mainForm)).then(async result => {
          const data = result.data
          if (data.data.result === true) {
            await this.checkUsrClmLimRes().then((x) => {
              this.doPromptAuth(x, 'reserve')
            })
          } else if (data.data.result2 === true) {
            await this.checkUsrClmLimPayt().then((x) => {
              this.doPromptAuth(x, 'payment')
            })
          } else if (data.data.result3 === true) {
            await this.checkUsrClmLimStatus().then((x) => {
              this.doPromptAuth(x, 'status')
            })
          }
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.loadingFlag = false
            this.$toast.error(data.messages[0].message)
          }
        })
        this.loadingFlag = false
      } else {
        this.loadingFlag = false
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async checkPendStatus() {
      let apiUrl = this.$store.state.commons.menu.getPendClmAll
      if (apiUrl) {
        this.loadingFlag = true
        this.mainForm.clmNo = this.commonInfo.clmNo
        this.$http.get(expandURI(apiUrl, this.mainForm)).then(async result => {
          const data = result.data
          if (data.data.result3 === true) {
            this.checkPStatus = true
          }
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.loadingFlag = false
            this.$toast.error(data.messages[0].message)
          }
        })
        this.loadingFlag = false
      } else {
        this.loadingFlag = false
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCloseEnterPassword() {
      this.promptCaptureAuth = false
      this.promptAuth = true
    },
    returnClmManagement() {
      this.$root.$emit('leaveClaim')
      this.$router.push({ name: 'mngClaim' })
    }
  },
  mixins: [
    commonMixins,
    MessageMixin
  ]
}
